import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, shelfItemShape, ugcCommentShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import CommentDisplay from '../../../shared/UGC/CommentDisplay';

import './CommentInfo.scss';

export default class ShelfListItemCommentInfo extends React.PureComponent {
  render() {
    const {
      bib,
      item,
      owner,
      ownerCommentForBib,
      commentsTransactions,
      shelfTransactions,
      commentsActions,
      shelfActions
    } = this.props;

    if (ownerCommentForBib) {
      return (
        <div className="cp-shelf-list-item-comment-info">
          <DisplayHeading>
            <FormattedMessage id="ugc_comment_display_label" />
          </DisplayHeading>
          <CommentDisplay
            bib={bib}
            shelfItem={item}
            owner={owner}
            comment={ownerCommentForBib}
            commentsTransactions={commentsTransactions}
            shelfTransactions={shelfTransactions}
            commentsActions={commentsActions}
            shelfActions={shelfActions}
          />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemCommentInfo.propTypes = {
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerCommentForBib: ugcCommentShape,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
